import React, { useEffect, useRef } from "react";
import L from "leaflet";
import { STATUS_META } from "@/lib/format";

// Fix default marker assets (not used — we use divIcon) and render points.
export function LeafletMap({ points = [], height = 300, zoom = 11, className = "" }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    mapRef.current = L.map(ref.current, { scrollWheelZoom: false }).setView([-33.8688, 151.2093], zoom);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap", maxZoom: 19,
    }).addTo(mapRef.current);
    layerRef.current = L.layerGroup().addTo(mapRef.current);
    return () => { mapRef.current?.remove(); mapRef.current = null; };
  }, [zoom]);

  useEffect(() => {
    const map = mapRef.current;
    const layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    const valid = points.filter((p) => p.lat != null && p.lng != null);
    if (!valid.length) return;
    valid.forEach((p) => {
      const color = (STATUS_META[p.status] || {}).dot || "#FF6500";
      const icon = L.divIcon({
        className: "",
        html: `<div class="pod-pin" style="background:${color}"></div>`,
        iconSize: [22, 22], iconAnchor: [11, 22],
      });
      const m = L.marker([p.lat, p.lng], { icon }).addTo(layer);
      if (p.label) m.bindPopup(p.label);
    });
    if (valid.length === 1) {
      map.setView([valid[0].lat, valid[0].lng], 15);
    } else {
      map.fitBounds(L.latLngBounds(valid.map((p) => [p.lat, p.lng])).pad(0.2));
    }
    setTimeout(() => map.invalidateSize(), 150);
  }, [points]);

  return <div ref={ref} data-testid="leaflet-map" className={`overflow-hidden rounded-xl ${className}`} style={{ height }} />;
}
